import { render, staticRenderFns } from "./AnimaisEstimacao.vue?vue&type=template&id=26cd75a8"
import script from "./AnimaisEstimacao.vue?vue&type=script&lang=js"
export * from "./AnimaisEstimacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports